<template>
  <div class="metronom">
    <div class="metronom__body">
      <img src="storage/app/media/metronom_body.svg" alt="">
      <div class="metronom__arrow">
        <img src="storage/app/media/metronom_arrow1.svg" alt="" :class="arrow_step">
      </div>
    </div>
    <div class="metronom__seconds">{{ seconds_count }}</div>
    <!--<div class="metronom__txt">{{ params.bpm }}</div>-->
  </div>
</template>

<script>
//import { soundMix } from '../../../../mixins/sound'
//import moment from 'moment'
import SoundClass from '../../../../classes/sound_class'

export default {
  inject: ['params'],
  name: "game_body",
  //mixins: [ soundMix ],
  data() {
    return {
      metronom_timer: '',
      time_timer: '',
      time: {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        total_ms: 0
      },
      arrow_step: '',
      sound: ''
    }
  },
  props: {
    items: '',
    active: ''
  },
  watch: {
    active: 'onFinish'
  },
  computed: {
    timerSpeed() {
      return 60 / this.params.bpm * 1000;
    },
    seconds_count() {
      return this.time.total_ms / 1000;
    }
  },
  methods: {
    startApp() {
      console.log('start app');
      this.startMetronomTimer(this.setArrowStep, this.playSound);
      this.startTimeTimer();
    },

    startTimeTimer() {
      let duration = moment.duration({
        'seconds': 0,
      });
      this.time_timer = setInterval(() => {
        duration = moment.duration(duration.asSeconds() + 1, 'seconds');
        this.time = duration._data;
        this.time.total_ms = duration._milliseconds;
      }, 1000);
    },

    startMetronomTimer(cb, cb2) {
      let i = 0;
      this.metronom_timer = setInterval(() => {
        cb(i);
        cb2(i);
        i++;
      }, this.timerSpeed);
    },

    setArrowStep(i) {
      this.arrow_step = (i % 2 === 0) ? 'tick' : 'tock';
    },

    playSound(i) {
      let sound1 = 'click3';
      let sound2 = this.params.has_accent ? 'click1' : sound1;
      this.sound.play((i % 4 === 0) ? sound2 : sound1);
    },

    stopTimers() {
      clearInterval(this.metronom_timer);
      clearInterval(this.time_timer);
    },

    onFinish(){
      console.log('on finish');
      this.stopTimers();
      this.$emit('onFinish', this.time);
    }
  },
  mounted() {
    this.sound = new SoundClass(this, 'main_library');
    this.startApp();
  },
  beforeDestroy() {
    this.stopTimers();
  }
}
</script>